@if (state.isReady()) {
  <div>
    <div class="row" id="pdf-view-navigation">
      <div class="col-md-5">
        <button
          class="btn btn-secondary btn-sm tool-bar-button"
          (click)="zoomOut()"
          title="Zoom out"
          [disabled]="this.zoom <= this.minZoom">
          <span class="fas fa-lg fa-search-minus"></span>
        </button>
        <button
          class="btn btn-secondary btn-sm ms-1 tool-bar-button"
          (click)="zoomIn()"
          title="Zoom in"
          [disabled]="this.zoom >= this.maxZoom">
          <span class="fas fa-lg fa-search-plus"></span>
        </button>

        @if (totalPages > 1) {
          <span>
            <button
              class="btn btn-secondary btn-sm tool-bar-button ms-2"
              [disabled]="page === 1 || showAll"
              (click)="previousPage()"
              title="Previous page">
              <span class="fas fa-lg fa-angle-left"></span>
            </button>
            <button
              class="btn btn-secondary btn-sm tool-bar-button ms-1"
              [disabled]="page >= totalPages || showAll"
              (click)="nextPage()"
              title="Next page">
              <span class="fas fa-lg fa-angle-right"></span>
            </button>

            @if (!showAll && canShowAll) {
              <button
                class="btn btn-secondary btn-sm tool-bar-button ms-2"
                (click)="toggleShowAll()"
                [title]="showAllButtonText">
                <span class="far fa-lg fa-fw fa-copy"></span>
              </button>
            }
            @if (showAll) {
              <button
                class="btn btn-secondary btn-sm tool-bar-button ms-2"
                (click)="toggleShowAll()"
                [title]="showAllButtonText">
                <span class="far fa-lg fa-fw fa-file"></span>
              </button>
            }
          </span>
        }
      </div>

      <div class="col-md-2 text-center">
        @if (totalPages > 1 && !showAll) {
          <div class="text-sm">Page {{ page + " / " + totalPages }}</div>
        }
        @if (totalPages > 1 && showAll) {
          <div class="text-sm">All {{ totalPages }} pages</div>
        }
      </div>

      <div class="col-md-5"></div>
    </div>
  </div>
} @else {
  <ch-status [state]="state" (buttonEvent)="onStatusButton($event)"></ch-status>
  @if (state.isLoading()) {
    <progress value="{{ loadedBytes }}" max="{{ totalBytes }}"></progress>
  }
}
@if (urlReady) {
  <ch-pdf-viewer
    [src]="src"
    [zoom]="zoom"
    [showAll]="showAll"
    [page]="page"
    (loaded)="pdfLoadComplete($event)"
    (loadFailed)="pdfLoadFailed($event)"
    (heightChange)="height = $event"
    (pageChange)="onPageChange($event)"
    (loadProgress)="onProgress($event)"
    style="height: {{ height }}px"></ch-pdf-viewer>
}
